import * as React from 'react';
import { Helper } from '../../../../Helper';
import { ICreatePageFromTemplate } from '../../../../interfaces/ICreatePageFromTemplate';
import { ICreatePageFromTemplateResponse } from '../../../../interfaces/ICreatePageFromTemplateResponse';
import { IInstance } from '../../../../interfaces/IInstance';
import ContentOrganizerService from '../../../../services/ContentOrganizerService';
import { LocalizationService } from '../../../../services/LocalizationService';
import { IAButton } from '../../../button/Button';
import { IAMessageBar } from '../../../messageBar/MessageBar';
import { IAPanel } from '../../../panels';
import { IATextField } from '../../../textField/TextField';
import * as styles from './ContentOrganizerPanel.css';

export interface IProps {
  show: boolean;
  instance: IInstance;
  isMobile: boolean;
  environment: "Development" | "Test" | "Production";
  token: string;
  tenant: string;
  highlightColor: string;
  onClose: () => void;
}

export interface IState {
  pageTitle: string;
  pageTitleIsValid: boolean;
  showCreationError: boolean;
  validating: boolean;
}

export class ContentOrganizerPanel extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();
  private validationTimer: number;

  constructor(props: IProps) {
    super(props);
    this.state = {
      pageTitle: "",
      pageTitleIsValid: true,
      showCreationError: false,
      validating: false
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props !== this.props) {
      this.setState({
        pageTitle: "",
        pageTitleIsValid: true,
        showCreationError: false,
        validating: false
      })
    }
  }

  private validate(): void {
    ContentOrganizerService.isAddressAvailable(this.props.environment, this.props.token, this.props.tenant, this.state.pageTitle).then((pageTitleIsValid: boolean) => {
      this.setState({ pageTitleIsValid, validating: false });
    })
  }

  public render(): JSX.Element {
    let top = 0;
    if ((Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") && !document.getElementById("IA_navigator_vertical_menu") && !this.props.isMobile) {
      top = 88;
    }
    if (location.href.indexOf("intraactive-admin") !== -1) {
      top = 109;
    }
    return (
      <IAPanel
        open={this.props.show}
        transition={"slide"}
        showNavigationBar={true}
        navigatorTitle={`${this.localizationService.strings.ContentOrganizer_EditPanel_AddingAPageTo} ${this.props.instance?.title}`}
        marginTop={top}
        isMobile={this.props.isMobile}
        loading={false}
        width={this.props.isMobile ? window.innerWidth : 600}
        dataAutomationIdPrefix="content-organizer-panel"
        panelId="content-organizer-panel"
        navigationsBarContent={
          <IAButton
            label={this.localizationService.strings.ContentOrganizer_EditPanel_CreatePage}
            buttonColor={this.props.highlightColor}
            disbaled={this.state.pageTitle === "" || !this.state.pageTitleIsValid || this.state.validating}
            onClick={() => {
              this.setState({ showCreationError: false });
              const pageTemplate: ICreatePageFromTemplate = {
                title: this.state.pageTitle,
                template: "Handbook"
              }
              ContentOrganizerService.createPageFromTemplate(this.props.environment, this.props.token, this.props.tenant, this.props.instance.instanceName, pageTemplate).then((createPageFromTemplateResponse: ICreatePageFromTemplateResponse) => {
                if (createPageFromTemplateResponse) {
                  window.open(createPageFromTemplateResponse?.url, "_blank");
                  this.props.onClose();
                } else {
                  this.setState({ showCreationError: true });
                }
              })
            }}
            borderRadius={5}
            style={{
              float: "right",
              position: "relative",
              marginTop: 7,
              marginRight: 10
            }}
          />
        }
        close={() => {
          this.props.onClose();
        }}
      >
        <div className={styles.IA_contentOrganizerPanel}>
          <IATextField
            label={this.localizationService.strings.ContentOrganizer_Title}
            text={this.state.pageTitle}
            placeholder={this.localizationService.strings.ContentOrganizer_PageTitle}
            inputFieldStyle={{
              color: this.state.pageTitleIsValid || this.state.pageTitle === "" ? "#333333" : "red",
              borderColor: this.state.pageTitleIsValid || this.state.pageTitle === "" ? "#dddddd" : "red"
            }}
            onChange={(pageTitle: string) => {
              clearInterval(this.validationTimer);
              this.setState({validating: true});
              this.validationTimer = window.setTimeout(() => {
                this.validate();
              }, 1000);
              this.setState({ pageTitle, showCreationError: false });
              this.forceUpdate();
            }}
          />
          {!this.state.pageTitleIsValid &&
            <IAMessageBar
              type="error"
              content={this.localizationService.strings.ContentOrganizer_PageExits}
              icon="Error"
              style={{
                marginTop: 20
              }}
              showIcon={true}
              onDismiss={() => { }}
            />
          }
          {this.state.showCreationError &&
            <IAMessageBar
              type="error"
              content={this.localizationService.strings.ContentOrganizer_CreationOfPageTemplateFailed}
              icon="Error"
              style={{
                marginTop: 20
              }}
              showIcon={true}
              showCloseButton
              onDismiss={() => this.setState({ showCreationError: false })}
            />
          }
        </div>
      </IAPanel >
    );
  }


}